import { BaseInputFieldFilter, FilterLabelProps } from "@duosoftbg/nacid-components";
import React from "react";

const UsernameFilter = ({ label = "l.searchFilter.username", ...others }: FilterLabelProps) => {
  return <BaseInputFieldFilter label={label} fieldName={"username"} {...others} />;
};

export default UsernameFilter;
